const expandableText = {
  props: {
    maxHeight: {
      type: String,
      default: 0,
    },
    btnClassName: {
      type: String,
      default: 'btn--outline-black btn--block'
    }
  },
  template: `<div class="b-expandable-text">
        <div class="b-expandable-text__conts" :class="[expandedClass, disabledClass]">
            <slot></slot>
        </div>
        <div v-show="showToggleButton" class="b-expandable-text__btn-wrap">
            <button v-show="!expanded" @click="open" :class="btnClassName">
                <slot name="button-more"></slot>
            </button>
            <button v-show="expanded" @click="close" :class="btnClassName">
                <slot name="button-less"></slot>
            </button>
        </div>
    </div>`,
  data: function () {
    return {
      expanded: false,
      showToggleButton: false,
      scrollHeight: 0,
      $this: null,
      maxH: 0,
    };
  },
  mounted() {
    this.ini();
  },
  methods: {
    ini() {
      this.container = this.$el.querySelector(".b-expandable-text__conts");

      if (this.maxHeight) {
        this.$el.style.setProperty("--max-height", this.maxHeight + "px");
      }

      this.maxH = parseInt(getComputedStyle(this.container).getPropertyValue("--max-height"));

      this.scrollHeight = this.container.scrollHeight + 80;

      if (this.scrollHeight > this.maxH) {
        this.showToggleButton = true;
      }
    },
    open() {
      this.expanded = true;
      this.container.style.maxHeight = `${this.scrollHeight}px`;
    },
    close() {
      this.expanded = false;
      this.container.style.maxHeight = `${this.maxH}px`;
    },
  },
  computed: {
    expandedClass() {
      return this.expanded ? "active" : "";
    },
    disabledClass() {
      return this.showToggleButton ? "" : "disabled";
    },
  },
};
